var $92a5647677217f37$exports = {};
document.querySelector("#masonry").addEventListener("click", (event)=>{
    if (document.fullscreenElement) {
        document.exitFullscreen();
        return;
    }
    if (event.target.tagName !== "IMG") return;
    event.target.requestFullscreen();
});


//# sourceMappingURL=fotografias.048cee06.js.map
